const numberPalette = (tokens) => {
    return {
        border: {
            width: {
                default: tokens.numberBorderWidthDefault,
                outlined: tokens.numberBorderWidthOutlined
            },
            radius: {
                default: tokens.numberBorderRadiusDefault,
                round: tokens.numberBorderRadiusRound
            }
        },
        size: {
            small: {
                height: tokens.numberHeightS,
                width: tokens.numberMinWidthS,
                padding: tokens.numberPaddingS
            },
            medium: {
                height: tokens.numberHeightM,
                width: tokens.numberMinWidthM,
                padding: tokens.numberPaddingM
            },
            input: {
                height: tokens.numberHeightInput,
                width: tokens.numberMinWidthInput,
                padding: tokens.numberPaddingInput
            }
        },
        font: {
            family: tokens.numberFontFamily,
            weight: tokens.numberFontWeight,
            letterSpacing: tokens.numberLetterSpacing,
            small: {
                size: tokens.numberFontSizeSmall,
                lineHeight: tokens.numberLineHeightSmall
            },
            medium: {
                size: tokens.numberFontSizeMedium,
                lineHeight: tokens.numberLineHeightMedium
            },
            input: {
                size: tokens.numberFontSizeInput,
                lineHeight: tokens.numberLineHeightInput
            }
        },
        static: {
            subtle: {
                background: tokens.numberColorBgStaticSubtle,
                border: tokens.numberColorBorderStaticSubtle,
                text: tokens.numberColorTextStaticSubtle
            },
            emphasis: {
                background: tokens.numberColorBgStaticEmphasis,
                border: tokens.numberColorBorderStaticEmphasis,
                text: tokens.numberColorTextStaticEmphasis
            },
            neutral: {
                background: tokens.numberColorBgStaticNeutral,
                border: tokens.numberColorBorderStaticNeutral,
                text: tokens.numberColorTextStaticNeutral
            }
        },
        interactive: {
            subtle: {
                background: {
                    default: tokens.numberColorBgInteractiveSubtleDefault,
                    hover: tokens.numberColorBgInteractiveSubtleHover,
                    focus: tokens.numberColorBgInteractiveSubtleFocus,
                    selected: {
                        default: tokens.numberColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.numberColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.numberColorBorderInteractiveSubtleDefault,
                    hover: tokens.numberColorBorderInteractiveSubtleHover,
                    focus: tokens.numberColorBorderInteractiveSubtleFocus,
                    selected: {
                        default: tokens.numberColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.numberColorBorderInteractiveSubtleSelectedHover
                    }
                },
                text: tokens.numberColorTextInteractiveSubtle
            },
            neutral: {
                background: {
                    default: tokens.numberColorBgInteractiveNeutralDefault,
                    hover: tokens.numberColorBgInteractiveNeutralHover,
                    focus: tokens.numberColorBgInteractiveNeutralFocus,
                    selected: {
                        default: tokens.numberColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.numberColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.numberColorBorderInteractiveNeutralDefault,
                    hover: tokens.numberColorBorderInteractiveNeutralHover,
                    focus: tokens.numberColorBorderInteractiveNeutralFocus,
                    selected: {
                        default: tokens.numberColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.numberColorBorderInteractiveNeutralSelectedHover
                    }
                },
                text: tokens.numberColorTextInteractiveSubtle
            },
            emphasis: {
                background: {
                    default: tokens.numberColorBgInteractiveEmphasisDefault,
                    hover: tokens.numberColorBgInteractiveEmphasisHover,
                    focus: tokens.numberColorBgInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.numberColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.numberColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.numberColorBorderInteractiveEmphasisDefault,
                    hover: tokens.numberColorBorderInteractiveEmphasisHover,
                    focus: tokens.numberColorBorderInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.numberColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.numberColorBorderInteractiveEmphasisSelectedHover
                    }
                },
                text: tokens.numberColorTextInteractiveSubtle
            }
        },
        error: {
            subtle: {
                background: {
                    default: tokens.numberColorBgErrorSubtle
                },
                text: tokens.numberColorTextError
            }
        }
    };
};
export default numberPalette;
//# sourceMappingURL=number.js.map